/* Sunnah Goods (Gilded) collection pages: filters, sorting, hero facts and quick add.
   Product data comes from Liquid (#sg-coll-data). card() mirrors snippets/sg-pc.liquid. */
(function () {
  'use strict';
  var dataEl = document.getElementById('sg-coll-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var api = function () { return window.SG || {}; };
  var money = function (c) { var a = api(); return a.money ? a.money(c) : '$' + (c / 100).toFixed(2); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- colour families ---------- */
  var PRINT = /flower|flowery|camo|leopard|tiger|jaguar|lynx|zebra|marble|stripe|pattern|print|cloud|fawn|leoger|shadow|day dream/i;
  var FAM_RULES = [
    ['Gold & yellow', function (n) { return (/\bgold\b/.test(n) && !/rose gold/.test(n)) || /yellow|amber|mustard/.test(n); }],
    ['Purple', function (n) { return /purple|lilac|plum|eggplant|heather|damson|violet|mauve/.test(n) || (/lavender/.test(n) && !/lavender gr[ae]y/.test(n)); }],
    ['Red & pink', function (n) { return /red|pink|burgundy|burgandy|merlot|maroon|rose|blush|fuchsia|raspberry|ruby|salmon|flamingo|ember|wine|coral/.test(n); }],
    ['Green & teal', function (n) { return /green|olive|teal|mint|sage|emerald|petrol|oasis|artichoke|caribbean|turquoise/.test(n); }],
    ['Blue & navy', function (n) { return /blue|navy|midnight|mid-night|ocean|glacier|livid|denim/.test(n); }],
    ['Grey', function (n) { return /grey|gray|charcoal|smoke|ashfall|mist|pebble|silver|slate/.test(n); }],
    ['Black', function (n) { return /black|obsidian|onyx/.test(n); }],
    ['White & cream', function (n) { return /white|cream|ivory|pearl|frost|saudi|snow|dawn|dune|linen/.test(n); }],
    ['Beige & brown', function (n) { return /beige|brown|coffee|camel|\btan\b|cashmere|caf|caramel|chestnut|clay|hazel|bronze|copper|desert|sahara|khaki|taupe|bedouin|almond|stone|sand|fig|latte|mocha|nude|espresso/.test(n); }]
  ];
  var FAMS = ['Black', 'White & cream', 'Beige & brown', 'Grey', 'Blue & navy', 'Green & teal', 'Red & pink', 'Purple', 'Gold & yellow', 'Prints'];
  var DOT = { 'Black': '#141414', 'White & cream': '#f3eee2', 'Beige & brown': '#a98563', 'Grey': '#8d8d8a', 'Blue & navy': '#2f4a7a', 'Green & teal': '#3f6b56', 'Red & pink': '#b0414f', 'Purple': '#6a3e8c', 'Gold & yellow': '#c9a24a' };
  function family(name, hex) {
    if (hex === 'pattern' || PRINT.test(name)) return 'Prints';
    var n = String(name).toLowerCase();
    for (var i = 0; i < FAM_RULES.length; i++) if (FAM_RULES[i][1](n)) return FAM_RULES[i][0];
    return null;
  }

  /* ---------- sizes ---------- */
  var SIZES = ['S', 'M', 'L', 'XL', 'XXL', '3XL', 'One size'];
  var FIT = { s: 'S', small: 'S', m: 'M', medium: 'M', l: 'L', large: 'L', xl: 'XL', xlarge: 'XL', xxl: 'XXL', '2xl': 'XXL', xxlarge: 'XXL', '3xl': '3XL', xxxl: '3XL', onesize: 'One size', os: 'One size' };
  function fit(t) { return FIT[String(t).toLowerCase().replace(/[\s.]+/g, '')] || null; }
  function sizeInfo(vals) {
    var sb = [], len = [];
    vals.forEach(function (v) {
      var s = String(v).trim(), m = s.match(/^(\d{2})(?:\s+(.+))?$/);
      if (m && +m[1] >= 48 && +m[1] <= 70) { if (len.indexOf(+m[1]) < 0) len.push(+m[1]); if (m[2]) { var f = fit(m[2]); if (f && sb.indexOf(f) < 0) sb.push(f); } return; }
      s.split(/\s*[-\/]\s*/).forEach(function (part) { var f = fit(part); if (f && sb.indexOf(f) < 0) sb.push(f); });
    });
    sb.sort(function (a, b) { return SIZES.indexOf(a) - SIZES.indexOf(b); });
    len.sort(function (a, b) { return a - b; });
    return { sb: sb, len: len };
  }

  /* ---------- prepare products ---------- */
  function prep(p, i) {
    p.o = i;
    var co = p.co >= 0 ? p.op[p.co] : null;
    p.cols = co ? co.v.map(function (v) { var avail = p.vs.some(function (x) { return x[2] && x[1][p.co] === v[0]; }); return [v[0], avail, v[1] || '#b9ad9a']; }) : [];
    p.fam = [];
    p.cols.forEach(function (c) { if (!c[1]) return; var f = family(c[0], c[2]); if (f && p.fam.indexOf(f) < 0) p.fam.push(f); });
    var si = p.so >= 0 ? sizeInfo(p.op[p.so].v.filter(function (v) { return p.vs.some(function (x) { return x[2] && x[1][p.so] === v[0]; }); }).map(function (v) { return v[0]; })) : { sb: [], len: [] };
    p.sb = si.sb; p.len = si.len;
    p.off = p.c > p.p ? Math.floor((p.c - p.p) * 100 / p.c) : 0;
    return p;
  }
  var N1 = D.noun || 'style', N2 = D.nouns || N1 + 's';
  var P = (D.p || []).map(prep);
  var X = (D.x || []).map(function (p, i) { return prep(p, 1000 + i); });
  var BY = {};
  X.concat(P).forEach(function (p) { BY[p.h] = p; });

  var SUBS = [], FH = D.fh || 'Category';
  if (D.kind === 'parent') {
    SUBS = (D.kids || []).map(function (k) { return [k[0], k[1]]; });
    P.forEach(function (p) { p.subs = (D.kids || []).filter(function (k) { return k[2].indexOf(p.h) > -1; }).map(function (k) { return k[0]; }); });
  } else {
    SUBS = (D.subs || []).map(function (s) { return [s, s]; });
    P.forEach(function (p) { p.subs = (p.st || []).filter(function (s) { return (D.subs || []).indexOf(s) > -1; }); });
  }
  SUBS = SUBS.filter(function (s) { return P.some(function (p) { return p.subs.indexOf(s[0]) > -1; }); });
  var SUBN = {}; SUBS.forEach(function (s) { SUBN[s[0]] = s[1]; });

  /* ---------- hero facts ---------- */
  function rangeTxt(a) { return a.length ? (a.length > 1 ? a[0] + ' to ' + a[a.length - 1] : String(a[0])) : ''; }
  function facts() {
    var cols = [], sb = [], len = [], minp = 0;
    P.forEach(function (p) {
      p.cols.forEach(function (c) { if (cols.indexOf(c[0].toLowerCase()) < 0) cols.push(c[0].toLowerCase()); });
      p.sb.forEach(function (s) { if (s !== 'One size' && sb.indexOf(s) < 0) sb.push(s); });
      p.len.forEach(function (l) { if (len.indexOf(l) < 0) len.push(l); });
      if (!minp || p.p < minp) minp = p.p;
    });
    sb.sort(function (a, b) { return SIZES.indexOf(a) - SIZES.indexOf(b); }); len.sort(function (a, b) { return a - b; });
    var T = { count: P.length ? String(P.length) : '', from: minp ? money(minp) : '', colours: cols.length > 1 ? String(cols.length) : '', sizes: rangeTxt(sb), lengths: rangeTxt(len) };
    $$('[data-facts] [data-tpl]').forEach(function (el) {
      var empty = false;
      var html = esc(el.getAttribute('data-tpl')).replace(/\[(kid:)?([\w-]+)\]/g, function (m, kid, key) {
        var v = '';
        if (kid) { var k = (D.kids || []).filter(function (x) { return x[0] === key; })[0]; v = k ? String(k[2].length) : ''; }
        else v = T[key] || '';
        if (!v) empty = true;
        return '<b>' + esc(v) + '</b>';
      });
      el.innerHTML = html; el.hidden = empty;
    });
  }

  /* ---------- product card (mirror of snippets/sg-pc.liquid) ---------- */
  function swatches(p) {
    if (!p.cols.length) return '';
    var shown = p.cols.slice(0, 5);
    return '<div class="sw" aria-label="' + p.cols.length + ' colour' + (p.cols.length > 1 ? 's' : '') + '">' + shown.map(function (c) {
      var pat = c[2] === 'pattern';
      return '<i title="' + esc(c[0]) + (c[1] ? '' : ' (sold out)') + '" class="' + (pat ? 'pattern ' : '') + (c[1] ? '' : 'out') + '" style="' + (pat ? '' : 'background:' + esc(c[2])) + '"></i>';
    }).join('') + (p.cols.length > 5 ? '<em>+' + (p.cols.length - 5) + '</em>' : '') + '</div>';
  }
  function card(p) {
    var b = [];
    if (p.off >= 20) b.push('<span class="sale">Save ' + p.off + '%</span>');
    if (p.b) b.push('<span>' + esc(p.b) + '</span>');
    if (p.low) b.push('<span class="low">Few left</span>');
    if (!p.av) b.push('<span class="sale">Sold out</span>');
    var alt = !!p.img[1];
    return '<article class="pc" data-h="' + esc(p.h) + '">' +
      '<div class="imw"><a class="im" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
      (p.img[0] ? '<img class="main' + (alt ? ' has-alt' : '') + '" src="' + esc(p.img[0]) + '" alt="" loading="lazy" decoding="async" width="700" height="1050">' : '') +
      (alt ? '<img class="alt" src="' + esc(p.img[1]) + '" alt="" loading="lazy" decoding="async" width="700" height="1050">' : '') +
      '<span class="bd">' + b.join('') + '</span></a>' +
      (p.av ? '<button class="qa" type="button" data-qa="' + esc(p.h) + '" aria-label="Quick add ' + esc(p.n) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>' + (p.one ? 'Add' : 'Quick add') + '</span></button>' : '') + '</div>' +
      swatches(p) +
      '<h3><a href="' + esc(p.u) + '">' + esc(p.n) + '</a></h3>' +
      (p.nt ? '<p class="nt">' + esc(p.nt) + '</p>' : '') +
      '<p class="pr"><span>' + (p.frm ? 'From ' : '') + money(p.p) + '</span>' + (p.c > p.p ? '<s>' + money(p.c) + '</s>' : '') + '</p>' +
      '</article>';
  }

  /* ---------- filter state ---------- */
  var PRICES = [['u25', 'Under $25', 0, 2500], ['25-50', '$25 to $50', 2500, 5000], ['50-75', '$50 to $75', 5000, 7500], ['75', '$75 and over', 7500, 1e12]];
  var st = { sub: {}, size: {}, len: {}, fam: {}, price: {}, stock: false, sale: false, sort: 'featured' };
  var keys = function (o) { return Object.keys(o); };
  var n0 = function (o) { return keys(o).length; };
  function any(arr, set) { return arr.some(function (v) { return set[String(v)]; }); }
  function match(p, skip) {
    if (skip !== 'sub' && n0(st.sub) && !any(p.subs, st.sub)) return false;
    if (skip !== 'size' && n0(st.size) && !any(p.sb, st.size)) return false;
    if (skip !== 'len' && n0(st.len) && !any(p.len, st.len)) return false;
    if (skip !== 'fam' && n0(st.fam) && !any(p.fam, st.fam)) return false;
    if (skip !== 'price' && n0(st.price) && !keys(st.price).some(function (k) { var r = PRICES.filter(function (x) { return x[0] === k; })[0]; return p.p >= r[2] && p.p < r[3]; })) return false;
    if (st.stock && p.low) return false;
    if (st.sale && !(p.c > p.p)) return false;
    return true;
  }
  function sorted(list) {
    var l = list.slice();
    if (st.sort === 'low') l.sort(function (a, b) { return a.p - b.p; });
    else if (st.sort === 'high') l.sort(function (a, b) { return b.p - a.p; });
    else if (st.sort === 'save') l.sort(function (a, b) { return (b.c > b.p ? b.c - b.p : 0) - (a.c > a.p ? a.c - a.p : 0); });
    else if (st.sort === 'az') l.sort(function (a, b) { return a.n.localeCompare(b.n); });
    else l.sort(function (a, b) { return a.o - b.o; });
    return l;
  }
  function chk(group, val, label, count, extra) {
    var id = 'f-' + group + '-' + String(val).replace(/[^a-z0-9]/gi, ''), on = !!st[group][val];
    return '<label class="fchk' + (count || on ? '' : ' dis') + '" for="' + id + '"><input type="checkbox" id="' + id + '" data-f="' + group + '" value="' + esc(val) + '" ' + (on ? 'checked' : '') + ' ' + (count || on ? '' : 'disabled') + '>' + (extra || '') + '<span>' + esc(label) + '</span><span class="c">' + count + '</span></label>';
  }
  function filtersHTML() {
    var h = '';
    if (SUBS.length) h += '<div class="fgroup"><h3>' + esc(FH) + '</h3>' + SUBS.map(function (s) { return chk('sub', s[0], s[1], P.filter(function (p) { return p.subs.indexOf(s[0]) > -1 && match(p, 'sub'); }).length); }).join('') + '</div>';
    var sz = SIZES.filter(function (s) { return P.some(function (p) { return p.sb.indexOf(s) > -1; }); });
    if (sz.length) h += '<div class="fgroup"><h3>Size</h3><div class="fsizes">' + sz.map(function (s) { var n = P.filter(function (p) { return p.sb.indexOf(s) > -1 && match(p, 'size'); }).length, on = !!st.size[s]; return '<button type="button" data-fs="size" data-v="' + s + '" aria-pressed="' + on + '" ' + (n || on ? '' : 'disabled') + '>' + s + '</button>'; }).join('') + '</div></div>';
    var L = []; P.forEach(function (p) { p.len.forEach(function (l) { if (L.indexOf(l) < 0) L.push(l); }); }); L.sort(function (a, b) { return a - b; });
    if (L.length) h += '<div class="fgroup"><h3>Thobe length</h3><div class="fsizes">' + L.map(function (s) { var n = P.filter(function (p) { return p.len.indexOf(s) > -1 && match(p, 'len'); }).length, on = !!st.len[String(s)]; return '<button type="button" data-fs="len" data-v="' + s + '" aria-pressed="' + on + '" ' + (n || on ? '' : 'disabled') + '>' + s + '</button>'; }).join('') + '</div></div>';
    var F = FAMS.filter(function (f) { return P.some(function (p) { return p.fam.indexOf(f) > -1; }); });
    if (F.length) h += '<div class="fgroup"><h3>Colour</h3><div class="fcols">' + F.map(function (f) { return chk('fam', f, f, P.filter(function (p) { return p.fam.indexOf(f) > -1 && match(p, 'fam'); }).length, '<span class="dot ' + (f === 'Prints' ? 'pattern' : '') + '" style="' + (f === 'Prints' ? '' : 'background:' + DOT[f]) + '"></span>'); }).join('') + '</div></div>';
    h += '<div class="fgroup"><h3>Price</h3>' + PRICES.map(function (r) { return chk('price', r[0], r[1], P.filter(function (p) { return p.p >= r[2] && p.p < r[3] && match(p, 'price'); }).length); }).join('') + '</div>';
    var sale = P.filter(function (p) { return p.c > p.p; }).length;
    h += '<div class="fgroup"><h3>Offers and stock</h3>' + (sale ? '<label class="fchk" for="f-sale"><input type="checkbox" id="f-sale" data-t="sale" ' + (st.sale ? 'checked' : '') + '><span>On sale</span><span class="c">' + sale + '</span></label>' : '') + '<label class="fchk" for="f-stock"><input type="checkbox" id="f-stock" data-t="stock" ' + (st.stock ? 'checked' : '') + '><span>Hide items with few left</span></label></div>';
    return h;
  }
  function pillsHTML() {
    var a = [];
    keys(st.sub).forEach(function (v) { a.push(['sub', v, SUBN[v] || v]); });
    keys(st.size).forEach(function (v) { a.push(['size', v, 'Size ' + v]); });
    keys(st.len).forEach(function (v) { a.push(['len', v, 'Length ' + v]); });
    keys(st.fam).forEach(function (v) { a.push(['fam', v, v]); });
    keys(st.price).forEach(function (v) { a.push(['price', v, PRICES.filter(function (r) { return r[0] === v; })[0][1]]); });
    if (st.sale) a.push(['sale', '', 'On sale']);
    if (st.stock) a.push(['stock', '', 'Hiding few left']);
    if (!a.length) return '';
    return a.map(function (x) { return '<span class="pill">' + esc(x[2]) + '<button type="button" data-rm="' + x[0] + '" data-v="' + esc(x[1]) + '" aria-label="Remove ' + esc(x[2]) + '">&times;</button></span>'; }).join('') + '<button type="button" class="clear" data-clear>Clear all</button>';
  }
  function activeCount() { return n0(st.sub) + n0(st.size) + n0(st.len) + n0(st.fam) + n0(st.price) + (st.sale ? 1 : 0) + (st.stock ? 1 : 0); }
  function isDefault() { return !activeCount() && st.sort === 'featured'; }

  var grid = $('#grid'), firstPaint = true;
  function render() {
    var list = sorted(P.filter(function (p) { return match(p); }));
    var cnt = $('#count');
    if (cnt) { var one = n0(st.sub) === 1 ? keys(st.sub)[0] : null; cnt.innerHTML = '<b>' + list.length + '</b> ' + (list.length === 1 ? N1 : N2) + (one ? ' in ' + esc(SUBN[one] || one) : ''); }
    if (grid && !(firstPaint && isDefault())) {
      grid.innerHTML = list.map(card).join('') || '<div class="empty"><p>No ' + N2 + ' match these filters.</p><button class="btn btn-secondary" type="button" data-clear>Clear filters</button></div>';
    }
    firstPaint = false;
    $$('.fside-host').forEach(function (h) { h.innerHTML = filtersHTML(); });
    var pills = $('#pills'); if (pills) pills.innerHTML = pillsHTML();
    var n = activeCount();
    $$('.fbtn .n').forEach(function (x) { x.textContent = n; x.hidden = !n; });
    $$('.rail button[data-sub]').forEach(function (b) { var s = b.getAttribute('data-sub'); b.setAttribute('aria-pressed', String((n0(st.sub) === 1 && !!st.sub[s]) || (!n0(st.sub) && s === 'all'))); });
    var ap = $('#f-apply'); if (ap) ap.textContent = 'Show ' + list.length + ' ' + (list.length === 1 ? N1 : N2);
  }
  function setHash() { var s = n0(st.sub) === 1 ? keys(st.sub)[0] : ''; try { history.replaceState(null, '', s ? '#' + s : location.pathname + location.search); } catch (e) {} }
  function fromHash() { var h = decodeURIComponent(location.hash.replace('#', '')); if (h && SUBN[h]) { st.sub = {}; st.sub[h] = true; } }
  function toTool() { var t = $('#ctool'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  if (grid) {
    d.addEventListener('change', function (e) {
      var f = e.target.closest('[data-f]');
      if (f) { var set = st[f.getAttribute('data-f')]; if (f.checked) set[f.value] = true; else delete set[f.value]; if (f.getAttribute('data-f') === 'sub') setHash(); render(); return; }
      var t = e.target.closest('[data-t]');
      if (t) { st[t.getAttribute('data-t')] = t.checked; render(); return; }
      if (e.target.id === 'sort') { st.sort = e.target.value; render(); }
    });
    d.addEventListener('click', function (e) {
      var s = e.target.closest('[data-fs]');
      if (s) { var set = st[s.getAttribute('data-fs')], v = s.getAttribute('data-v'); if (set[v]) delete set[v]; else set[v] = true; render(); return; }
      var r = e.target.closest('[data-rm]');
      if (r) { var g = r.getAttribute('data-rm'); if (g === 'sale' || g === 'stock') st[g] = false; else delete st[g][r.getAttribute('data-v')]; if (g === 'sub') setHash(); render(); return; }
      if (e.target.closest('[data-clear]')) { st.sub = {}; st.size = {}; st.len = {}; st.fam = {}; st.price = {}; st.sale = st.stock = false; setHash(); render(); return; }
      var rb = e.target.closest('.rail button[data-sub]');
      if (rb) { st.sub = {}; var sv = rb.getAttribute('data-sub'); if (sv !== 'all') st.sub[sv] = true; setHash(); render(); toTool(); return; }
      if (e.target.closest('#open-filters')) { var a = api(); if (a.open) a.open('fdrawer', e.target.closest('#open-filters')); return; }
      if (e.target.closest('#f-apply')) { var a2 = api(); if (a2.close) a2.close(); }
    });
    window.addEventListener('hashchange', function () { fromHash(); render(); });
    var init = function () { fromHash(); facts(); render(); };
    if (d.readyState === 'complete') init(); else d.addEventListener('DOMContentLoaded', init);
  }

  /* ---------- quick add ---------- */
  var qp = null, sel = [];
  function realOpts(p) { return p.op.map(function (o, i) { return i; }).filter(function (i) { var o = p.op[i]; return !(o.v.length === 1 && /^default title$/i.test(o.v[0][0])); }); }
  function valOk(i, val) {
    return qp.vs.some(function (x) { return x[2] && x[1][i] === val && qp.op.every(function (o, j) { return j === i || sel[j] == null || x[1][j] === sel[j]; }); });
  }
  function current() { return qp.vs.filter(function (x) { return qp.op.every(function (o, j) { return x[1][j] === sel[j]; }); })[0]; }
  function renderQ() {
    var sh = $('#qsheet'); if (!sh) return;
    var p = qp;
    sh.querySelector('.qhead').innerHTML = (p.img[0] ? '<img src="' + esc(p.img[0]) + '" alt="">' : '<span></span>') + '<div><h2 id="q-title">' + esc(p.n) + '</h2><p class="pr">' + (p.frm ? 'From ' : '') + money(p.p) + (p.c > p.p ? '<s>' + money(p.c) + '</s>' : '') + '</p>' + (p.nt ? '<p class="qmsg" style="margin-top:.3rem">' + esc(p.nt) + '</p>' : '') + '</div><button class="icon-btn" type="button" data-close aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    var o = '';
    realOpts(p).forEach(function (i) {
      var opt = p.op[i];
      if (i === p.co) {
        var pat = opt.v.some(function (v) { return v[1] === 'pattern' || PRINT.test(v[0]); });
        o += '<div class="qopt"><h3>' + (pat || /design/i.test(opt.n) ? 'Design' : 'Colour') + ': <span>' + esc(sel[i] || 'Choose one') + '</span></h3><div class="qsw">' + opt.v.map(function (v) {
          var ok = valOk(i, v[0]), hx = v[1] || '#b9ad9a', isPat = hx === 'pattern';
          return '<button type="button" data-qo="' + i + '" data-qv="' + esc(v[0]) + '" title="' + esc(v[0]) + (ok ? '' : ' (sold out)') + '" aria-label="' + esc(v[0]) + (ok ? '' : ', sold out') + '" aria-pressed="' + (sel[i] === v[0]) + '" ' + (ok ? '' : 'disabled') + ' class="' + (isPat ? 'pattern' : '') + '" style="' + (isPat ? '' : 'background:' + esc(hx)) + '"></button>';
        }).join('') + '</div></div>';
      } else if (opt.v.length === 1 && /^one size$/i.test(opt.v[0][0])) {
        o += '<p class="qmsg">One size.</p>';
      } else {
        var lens = i === p.so && p.len.length;
        o += '<div class="qopt"><h3>' + esc(opt.n) + ': <span>' + esc(sel[i] || 'Choose one') + '</span></h3><div class="qsz">' + opt.v.map(function (v) {
          var ok = valOk(i, v[0]);
          return '<button type="button" data-qo="' + i + '" data-qv="' + esc(v[0]) + '" aria-pressed="' + (sel[i] === v[0]) + '" ' + (ok ? '' : 'disabled') + '>' + esc(v[0]) + '</button>';
        }).join('') + '</div>' + (lens && D.lenNote ? '<p class="qmsg">' + esc(D.lenNote) + '</p>' : '') + '</div>';
      }
    });
    sh.querySelector('.qbody').innerHTML = o;
    sh.querySelector('.qact').innerHTML = '<button class="btn btn-primary" type="button" id="q-add">Add to cart</button><a href="' + esc(p.u) + '">See full details and size chart</a>';
    updQ();
  }
  function updQ() {
    var b = $('#q-add'); if (!b) return;
    var need = realOpts(qp).filter(function (i) { return sel[i] == null; }).map(function (i) { return i === qp.co ? 'colour' : qp.op[i].n.toLowerCase(); });
    if (need.length) { b.disabled = true; b.textContent = 'Choose ' + need.join(' and '); return; }
    var v = current();
    if (!v || !v[2]) { b.disabled = true; b.textContent = 'Sold out in this combination'; return; }
    b.disabled = false; b.textContent = 'Add to cart, ' + money(v[3]);
  }
  function addVariant(id, btn) {
    var a = api(); if (!a.add) { location.href = '/cart/add?id=' + id + '&quantity=1'; return; }
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    a.add([{ id: id, quantity: 1 }]).then(function () { if (a.close) a.close(); }).catch(function () {}).then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
  }
  function openQuick(h, btn) {
    var p = BY[h]; if (!p) return;
    if (p.one) { var v0 = p.vs.filter(function (x) { return x[2]; })[0]; if (v0) addVariant(v0[0], btn); return; }
    qp = p; sel = [];
    p.op.forEach(function (o, i) {
      if (realOpts(p).indexOf(i) < 0) { sel[i] = o.v[0][0]; return; }
      var av = o.v.filter(function (v) { return p.vs.some(function (x) { return x[2] && x[1][i] === v[0]; }); });
      if (av.length === 1) sel[i] = av[0][0];
    });
    renderQ();
    var a = api(); if (a.open) a.open('qsheet', btn);
  }
  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qa]');
    if (q) { e.preventDefault(); openQuick(q.getAttribute('data-qa'), q); return; }
    var ob = e.target.closest('[data-qo]');
    if (ob && !ob.disabled && qp) { var i = +ob.getAttribute('data-qo'), v = ob.getAttribute('data-qv'); sel[i] = sel[i] === v ? null : v; renderQ(); var again = $('[data-qo="' + i + '"][data-qv="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]'); if (again) again.focus(); return; }
    if (e.target.closest('#q-add') && qp) { var cur = current(); if (cur && cur[2]) addVariant(cur[0], e.target.closest('#q-add')); }
  });
})();
